import isTrimmedAndNonEmpty from "./isTrimmedAndNonEmpty";

export default function isAlphaNumeric({
  str,
  allowWhitespace = false,
  dollarSigns = false,
}: {
  str: string;
  allowWhitespace?: boolean;
  dollarSigns?: boolean;
}): boolean {
  let allowed = "a-zA-Z0-9";

  if (allowWhitespace) {
    allowed += " ";
  }

  if (dollarSigns) {
    allowed += "\\$";
  }

  return new RegExp(`^[${allowed}]*$`).test(str) && isTrimmedAndNonEmpty(str);
}
